import React from 'react';
import TodoItem from './TodoItem';

const TodosList = ({
  todos, handleCheck, deleteTodo, updateTodo,
}) => (
  <ul style={{ margin: '0 10px', paddingLeft: '0' }}>
    {todos.map((todo) => (
      <TodoItem
        key={todo.id}
        todo={todo}
        handleCheck={handleCheck}
        deleteTodo={deleteTodo}
        updateTodo={updateTodo}
      />
    ))}
  </ul>
);
export default TodosList;
